export const registerResources = {
  zh: {
    'register.hero.tag': '2026家庭友好企业评选',
    'register.hero.title1': '致敬每一份',
    'register.hero.titleHighlight': '家庭友好',
    'register.hero.title2': '共建温暖企业生态',
    'register.hero.subtitle':
      '"家庭友好企业"评选关注企业在育儿支持、亲子假期、灵活办公、亲职关怀等层面的实际投入，发掘并表彰真正以家庭为本的卓越雇主。',
    'register.hero.btnApply': '立即申报参选',
    'register.hero.btnRules': '了解评选规则',
    'register.hero.btnBenefits': '入选企业可获得',

    'register.timeline.title': '评选时间轴',
    'register.timeline.step1.title': '企业报名',
    'register.timeline.step1.date': '2026.08.05 - 2026.10.09',
    'register.timeline.step2.title': '调研评审',
    'register.timeline.step2.date': '报名后 - 2026.10',
    'register.timeline.step3.title': '结果确认',
    'register.timeline.step3.date': '2026.11 — 2026.12',
    'register.timeline.step4.title': '榜单发布',
    'register.timeline.step4.date': '2027.01',

    'register.form.sectionTitle': '评选报名',
    'register.form.title': '"家庭友好企业"评选报名',
    'register.form.subtitle':
      '提交报名后我们会在1个工作日内通过邮件向您发送企业账号与登录方式，请留意查收',
    'register.form.companyName.label': '参选企业名称',
    'register.form.companyName.placeholder': '请输入企业全称（与营业执照一致）',
    'register.form.companyName.required': '请输入参选企业名称',
    'register.form.contactName.label': '企业联系人姓名',
    'register.form.contactName.placeholder': '请输入联系人姓名',
    'register.form.contactName.required': '请输入企业联系人姓名',
    'register.form.contactTitle.label': '企业联系人岗位',
    'register.form.contactTitle.placeholder': '例如：HR总监/EVP 经理',
    'register.form.contactTitle.required': '请输入企业联系人岗位',
    'register.form.contactPhone.label': '企业联系人手机',
    'register.form.contactPhone.placeholder': '请输入手机号码',
    'register.form.contactPhone.required': '请输入企业联系人手机',
    'register.form.email.label': '企业联系人邮箱',
    'register.form.email.placeholder': '请输入邮箱地址',
    'register.form.email.required': '请输入有效的邮箱地址',
    'register.form.email.invalid': '邮箱格式不正确',
    'register.form.emailCode.label': '邮箱验证码',
    'register.form.emailCode.placeholder': '请输入邮箱验证码',
    'register.form.emailCode.required': '请输入邮箱验证码',
    'register.form.emailCode.sendError': '验证码发送失败，请检查后重试',
    'register.form.emailCode.getCode': '获取邮箱验证码',
    'register.form.emailCode.sending': '发送中…',
    'register.form.emailCode.resend': '重新发送验证码({seconds}秒)',
    'register.form.emailCode.hint': '十分钟内有效',
    'register.form.emailCode.spamHint': '邮件可能被误判为垃圾邮件，请留意查看',
    'register.form.license.label': '上传营业执照 / 工牌证明',
    'register.form.license.uploadText': '点击或拖拽上传文件',
    'register.form.license.hint': '支持 jpg / png / pdf · 最大 10 MB · 最多 5 个文件',
    'register.form.license.selectFile': '选择文件',
    'register.form.license.uploading': '上传中',
    'register.form.license.uploadFailed': '上传失败',
    'register.form.license.required': '请上传营业执照或工牌证明',
    'register.form.headcount.label': '企业人数',
    'register.form.headcount.placeholder': '请输入企业员工人数',
    'register.form.remark.label': '备注',
    'register.form.remark.placeholder': '如有其他补充说明，请在此填写',
    'register.form.agree.label': '确认声明',
    'register.form.agree.prefix': '我已阅读并同意 ',
    'register.form.agree.link': '《"家庭友好企业"评选隐私协议》',
    'register.form.agree.suffix': '，知晓本次报名信息将仅用于评选活动管理',
    'register.form.agree':
      '我已阅读并同意 《"家庭友好企业"评选隐私协议》，知晓本次报名信息将仅用于评选活动管理',
    'register.form.agree.required': '请阅读并同意隐私协议',
    'register.form.submit': '提交报名',
    'register.form.registered': '已报名',

    'register.success.title': '报名提交成功！',
    'register.success.desc': '我们会在1个工作日内通过邮件向您发送企业账号与登录方式，请留意查收',
    'register.success.autoClose': '{seconds}s后自动关闭',
    'register.success.btn': '返回报名详情',

    'register.error.title': '报名提交失败',
    'register.error.desc': '提交过程中遇到问题，请稍后重试',
    'register.error.btn': '返回',

    'register.incomplete.title': '报名信息未完善',
    'register.incomplete.desc1': '您的报名材料中仍有未填写的必填项，无法进行提交',
    'register.incomplete.desc2': '请完善后再次尝试提交',
    'register.incomplete.pending': '待完善：',
    'register.incomplete.btn': '去完善',

    'register.benefits.title': '入选企业可获得',
    'register.benefits.s1.heading': '定制化专业评估报告',
    'register.benefits.s1.body':
      '所有符合要求的参评企业，均可获得针对本企业家庭友好实践的科学、系统的评估，提供定制化分析报告、行业 Benchmark 及优秀实践案例参考。',
    'register.benefits.s2.heading': '荣誉认可与品牌背书',
    'register.benefits.s2.body':
      '在家庭友好方面有优秀实践的企业有机会入选年度榜单及标杆案例，获得专业机构认可，进一步提升企业在家庭友好建设及雇主品牌领域的行业影响力。',
    'register.benefits.s3.heading': '权威媒体品牌曝光',
    'register.benefits.s3.body':
      '榜单将联合中国新闻周刊等权威媒体，打造高规格传播矩阵，通过专题报道、深度解读等多元传播形式，为企业提供权威品牌背书。',
    'register.benefits.s4.heading': '高质量行业资源触达',
    'register.benefits.s4.body':
      '上榜企业将受邀参与在2027年1月于香港举办的"全球生育危机论坛"等行业活动，为企业提供高质量行业交流机会，自动激活大会现场及全网的百万量级曝光资源。',

    'register.rules.title': '评选规则',
    'register.rules.s1.heading': '报名企业条件',
    'register.rules.s1.item1': '企业员工总数不少于300人；',
    'register.rules.s1.item2': '在所属市场连续稳定经营满3年；',
    'register.rules.s1.item3': '上一年度未发生重大劳动纠纷、重大安全生产事故。',
    'register.rules.s2.heading': '评审流程',
    'register.rules.s2.body':
      '企业完成评估问卷填写后，专家团将依据评价体系开展综合评估，并对符合认证资格的企业启动材料核验，抽样要求企业提供佐证材料，最终形成综合评审结果。',
    'register.rules.s3.heading': '奖项设置',
    'register.rules.s3.item1':
      '家庭友好型企业认证：符合报名企业条件并通过合规性审核的企业均可获得认证。',
    'register.rules.s3.item2':
      '家庭友好型企业榜单：依据综合调研评分，从认证企业中遴选家庭友好实践表现卓越的企业入榜。',
    'register.rules.learnMore': '了解评选规则',
  },
  zh_TW: {
    'register.hero.tag': '2026家庭友善企業評選',
    'register.hero.title1': '致敬每一份',
    'register.hero.titleHighlight': '家庭友善',
    'register.hero.title2': '共建溫暖企業生態',
    'register.hero.subtitle':
      '"家庭友善企業"評選關注企業在育兒支持、親子假期、彈性辦公、親職關懷等層面的實際投入，發掘並表彰真正以家庭為本的卓越雇主。',
    'register.hero.btnApply': '立即申報參選',
    'register.hero.btnRules': '了解評選規則',
    'register.hero.btnBenefits': '入選企業可獲得',

    'register.timeline.title': '評選時間軸',
    'register.timeline.step1.title': '企業報名',
    'register.timeline.step1.date': '2026.08.05 - 2026.10.09',
    'register.timeline.step2.title': '研究評審',
    'register.timeline.step2.date': '報名後 - 2026.10',
    'register.timeline.step3.title': '結果確認',
    'register.timeline.step3.date': '2026.11 — 2026.12',
    'register.timeline.step4.title': '榜單發布',
    'register.timeline.step4.date': '2027.01',

    'register.form.sectionTitle': '評選報名',
    'register.form.title': '"家庭友善企業"評選報名',
    'register.form.subtitle':
      '提交報名後我們會在1個工作日內透過郵件向您發送企業帳號與登入方式，請留意查收',
    'register.form.companyName.label': '參選企業名稱',
    'register.form.companyName.placeholder': '請輸入企業全稱（與營業執照一致）',
    'register.form.companyName.required': '請輸入參選企業名稱',
    'register.form.contactName.label': '企業聯絡人姓名',
    'register.form.contactName.placeholder': '請輸入聯絡人姓名',
    'register.form.contactName.required': '請輸入企業聯絡人姓名',
    'register.form.contactTitle.label': '企業聯絡人職稱',
    'register.form.contactTitle.placeholder': '例如：HR總監/EVP 經理',
    'register.form.contactTitle.required': '請輸入企業聯絡人職稱',
    'register.form.contactPhone.label': '企業聯絡人手機',
    'register.form.contactPhone.placeholder': '請輸入手機號碼',
    'register.form.contactPhone.required': '請輸入企業聯絡人手機',
    'register.form.email.label': '企業聯絡人電子郵件',
    'register.form.email.placeholder': '請輸入電子郵件地址',
    'register.form.email.required': '請輸入有效的電子郵件地址',
    'register.form.email.invalid': '電子郵件格式不正確',
    'register.form.emailCode.label': '電子郵件驗證碼',
    'register.form.emailCode.placeholder': '請輸入電子郵件驗證碼',
    'register.form.emailCode.required': '請輸入電子郵件驗證碼',
    'register.form.emailCode.sendError': '驗證碼發送失敗，請檢查後重試',
    'register.form.emailCode.getCode': '獲取電子郵件驗證碼',
    'register.form.emailCode.sending': '發送中…',
    'register.form.emailCode.resend': '重新發送驗證碼({seconds}秒)',
    'register.form.emailCode.hint': '十分鐘內有效',
    'register.form.emailCode.spamHint': '郵件可能被誤判為垃圾郵件，請留意查看',
    'register.form.license.label': '上傳營業執照 / 工牌證明',
    'register.form.license.uploadText': '點擊或拖拽上傳文件',
    'register.form.license.hint': '支援 jpg / png / pdf · 最大 10 MB · 最多 5 個文件',
    'register.form.license.selectFile': '選擇文件',
    'register.form.license.uploading': '上傳中',
    'register.form.license.uploadFailed': '上傳失敗',
    'register.form.license.required': '請上傳營業執照或工牌證明',
    'register.form.headcount.label': '企業人數',
    'register.form.headcount.placeholder': '請輸入企業員工人數',
    'register.form.remark.label': '備註',
    'register.form.remark.placeholder': '如有其他補充說明，請在此填寫',
    'register.form.agree.label': '確認聲明',
    'register.form.agree.prefix': '我已閱讀並同意 ',
    'register.form.agree.link': '《"家庭友善企業"評選隱私協議》',
    'register.form.agree.suffix': '，知曉本次報名資訊將僅用於評選活動管理',
    'register.form.agree':
      '我已閱讀並同意 《"家庭友善企業"評選隱私協議》，知曉本次報名資訊將僅用於評選活動管理',
    'register.form.agree.required': '請閱讀並同意隱私協議',
    'register.form.submit': '提交報名',
    'register.form.registered': '已報名',

    'register.success.title': '報名提交成功！',
    'register.success.desc': '我們會在1個工作日內透過郵件向您發送企業帳號與登入方式，請留意查收',
    'register.success.autoClose': '{seconds}秒後自動關閉',
    'register.success.btn': '返回報名詳情',

    'register.error.title': '報名提交失敗',
    'register.error.desc': '提交過程中遇到問題，請稍後重試',
    'register.error.btn': '返回',

    'register.incomplete.title': '報名資訊未完善',
    'register.incomplete.desc1': '您的報名材料中仍有未填寫的必填項，無法進行提交',
    'register.incomplete.desc2': '請完善後再次嘗試提交',
    'register.incomplete.pending': '待完善：',
    'register.incomplete.btn': '去完善',

    'register.benefits.title': '入選企業可獲得',
    'register.benefits.s1.heading': '定制化專業評估報告',
    'register.benefits.s1.body':
      '所有符合要求的參評企業，均可獲得針對本企業家庭友善實踐的科學、系統的評估，提供定制化分析報告、行業 Benchmark 及優秀實踐案例參考。',
    'register.benefits.s2.heading': '榮譽認可與品牌背書',
    'register.benefits.s2.body':
      '在家庭友善方面有優秀實踐的企業有機會入選年度榜單及標桿案例，獲得專業機構認可，進一步提升企業在家庭友善建設及雇主品牌領域的行業影響力。',
    'register.benefits.s3.heading': '權威媒體品牌曝光',
    'register.benefits.s3.body':
      '榜單將聯合中國新聞周刊等權威媒體，打造高規格傳播矩陣，通過專題報道、深度解讀等多元傳播形式，為企業提供權威品牌背書。',
    'register.benefits.s4.heading': '高質量行業資源觸達',
    'register.benefits.s4.body':
      '上榜企業將受邀參與在2027年1月於香港舉辦的「全球生育危機論壇」等行業活動，為企業提供高質量行業交流機會，自動激活大會現場及全網的百萬量級曝光資源。',

    'register.rules.title': '評選規則',
    'register.rules.s1.heading': '報名企業條件',
    'register.rules.s1.item1': '企業員工總數不少於 300 人；',
    'register.rules.s1.item2': '在所屬市場連續穩定營運滿 3 年；',
    'register.rules.s1.item3': '上一年度未發生重大勞資爭議或重大安全生產事故。',
    'register.rules.s2.heading': '評審流程',
    'register.rules.s2.body':
      '企業完成評估問卷後，專家團隊將依據評價體系進行綜合評估，並針對符合認證資格的企業啟動資料核驗，抽樣要求企業提供相關佐證資料，最終形成綜合評審結果。',
    'register.rules.s3.heading': '獎項設置',
    'register.rules.s3.item1':
      '家庭友善企業認證：符合報名企業條件並通過合規性審核的企業，均可獲得認證。',
    'register.rules.s3.item2':
      '家庭友善企業榜單：依據綜合調研評分，從通過認證的企業中遴選家庭友善實踐表現卓越的企業入榜。',
    'register.rules.learnMore': '了解評選規則',
  },
  en: {
    'register.hero.tag': '2026 Family Friendly Employers List',
    'register.hero.title1': 'Honoring Every',
    'register.hero.titleHighlight': ' Family-Friendly',
    'register.hero.title2': 'Building a Warm Business Ecosystem',
    'register.hero.subtitle':
      'The Family Friendly Employers List recognizes companies that invest in childcare support, family leave, flexible work, and parental care — celebrating employers who truly put family first.',
    'register.hero.btnApply': 'Apply Now',
    'register.hero.btnRules': 'Learn Award Criteria',
    'register.hero.btnBenefits': 'Benefits for Winners',

    'register.timeline.title': 'Award Timeline',
    'register.timeline.step1.title': 'Apply',
    'register.timeline.step1.date': 'Aug 5 – Oct 9 2026',
    'register.timeline.step2.title': 'Survey',
    'register.timeline.step2.date': 'After Application - October 2026',
    'register.timeline.step3.title': 'Confirmed',
    'register.timeline.step3.date': 'Nov — Dec 2026',
    'register.timeline.step4.title': 'Announced',
    'register.timeline.step4.date': 'Jan 2027',

    'register.form.sectionTitle': 'Apply Now',
    'register.form.title': 'Family-Friendly Enterprise Award Application',
    'register.form.subtitle':
      'After you submit your registration, we will send your employer account to you via email within 1 business day. Please keep an eye on your inbox.',
    'register.form.companyName.label': 'Company Name',
    'register.form.companyName.placeholder': 'Enter full company name (as on business license)',
    'register.form.companyName.required': 'Please enter your company name',
    'register.form.contactName.label': 'Contact Person Name',
    'register.form.contactName.placeholder': 'Enter contact person name',
    'register.form.contactName.required': 'Please enter contact person name',
    'register.form.contactTitle.label': 'Contact Person Title',
    'register.form.contactTitle.placeholder': 'e.g. HR Director / EVP Manager',
    'register.form.contactTitle.required': 'Please enter contact person title',
    'register.form.contactPhone.label': 'Contact Person Phone',
    'register.form.contactPhone.placeholder': 'Enter phone number',
    'register.form.contactPhone.required': 'Please enter contact person phone',
    'register.form.email.label': 'Contact Email',
    'register.form.email.placeholder': 'Enter email address',
    'register.form.email.required': 'Please enter a valid email address',
    'register.form.email.invalid': 'Invalid email format',
    'register.form.emailCode.label': 'Email Verification Code',
    'register.form.emailCode.placeholder': 'Enter verification code',
    'register.form.emailCode.required': 'Please enter the verification code',
    'register.form.emailCode.sendError':
      'Verification code sending failed, please check and try again',
    'register.form.emailCode.getCode': 'Get Verification Code',
    'register.form.emailCode.sending': 'Sending…',
    'register.form.emailCode.resend': 'Resend Code ({seconds}s)',
    'register.form.emailCode.hint': 'Valid for 10 minutes',
    'register.form.emailCode.spamHint':
      'The email may be marked as spam. Please check your junk folder.',
    'register.form.license.label': 'Upload Business License / Staff Card',
    'register.form.license.uploadText': 'Click or drag file to upload',
    'register.form.license.hint': 'Supports jpg / png / pdf · Max 10 MB · Up to 5 files',
    'register.form.license.selectFile': 'Select File',
    'register.form.license.uploading': 'Uploading...',
    'register.form.license.uploadFailed': 'Upload failed',
    'register.form.license.required': 'Please upload business license or staff card',
    'register.form.headcount.label': 'Number of Employees',
    'register.form.headcount.placeholder': 'Enter number of employees',
    'register.form.remark.label': 'Remarks',
    'register.form.remark.placeholder': 'Additional information (optional)',
    'register.form.agree.label': 'Confirmation',
    'register.form.agree.prefix': 'I have read and agree to the ',
    'register.form.agree.link': '"Family-Friendly Enterprise Award" Privacy Policy',
    'register.form.agree.suffix':
      '. I understand that my application information will only be used for award management.',
    'register.form.agree':
      'I have read and agree to the "Family-Friendly Enterprise Award" Privacy Policy. I understand that my application information will only be used for award management.',
    'register.form.agree.required': 'Please read and agree to the privacy policy',
    'register.form.submit': 'Submit Application',
    'register.form.registered': 'Applied',

    'register.success.title': 'Application Submitted!',
    'register.success.desc':
      'We will send your enterprise Portal account to you via email within 1 business day. Please keep an eye on your inbox.',
    'register.success.autoClose': 'Auto-close in {seconds}s',
    'register.success.btn': 'Back to Application',

    'register.error.title': 'Submission Failed',
    'register.error.desc': 'An error occurred during submission. Please try again later.',
    'register.error.btn': 'Back',

    'register.incomplete.title': 'Application Incomplete',
    'register.incomplete.desc1':
      'Some required fields are missing. Please complete them before submitting.',
    'register.incomplete.desc2': 'Please complete them and try again.',
    'register.incomplete.pending': 'Missing: ',
    'register.incomplete.btn': 'Complete Now',

    'register.benefits.title': 'Benefits for Award Winners',
    'register.benefits.s1.heading': 'Customized Professional Assessment Report',
    'register.benefits.s1.body':
      'All qualifying participants will receive a science-based, systematic assessment of their family-friendly practices, including a customized analysis report, industry benchmarks, and best-practice case references.',
    'register.benefits.s2.heading': 'Honor Recognition & Brand Endorsement',
    'register.benefits.s2.body':
      'Companies with outstanding family-friendly practices have the opportunity to be featured on the annual list and as benchmark cases, gaining recognition from a professional institution and enhancing their influence in the employer brand space.',
    'register.benefits.s3.heading': 'Authoritative Media Brand Exposure',
    'register.benefits.s3.body':
      'The list will partner with authoritative media outlets to create a high-profile communications campaign, providing companies with credible brand endorsement through feature stories and in-depth coverage.',
    'register.benefits.s4.heading': 'High-Quality Industry Resource Access',
    'register.benefits.s4.body':
      'Listed companies will be invited to industry events such as the "Global Fertility Crisis Forum" in Hong Kong in January 2027, gaining high-quality networking opportunities and million-level exposure across the venue and online.',

    'register.rules.title': 'Award Criteria',
    'register.rules.s1.heading': 'Eligibility Requirements',
    'register.rules.s1.item1': 'The company must have at least 300 employees;',
    'register.rules.s1.item2':
      'The company must have maintained stable operations in its respective market for at least three consecutive years;',
    'register.rules.s1.item3':
      'The company must not have been involved in any major labor disputes or major workplace safety incidents in the previous year.',
    'register.rules.s2.heading': 'Evaluation Process',
    'register.rules.s2.body':
      'After completing the assessment questionnaire, companies will be evaluated by an expert panel based on the established evaluation framework. Eligible companies will undergo documentation verification, including the submission of supporting materials where required. Final results will be determined based on the overall assessment.',
    'register.rules.s3.heading': 'Awards & Recognition',
    'register.rules.s3.item1':
      'Family-Friendly Employer Certification: Companies that meet the eligibility requirements and pass the compliance review will receive the Family-Friendly Enterprise Certification.',
    'register.rules.s3.item2':
      'Family-Friendly Employer List: Based on the overall assessment scores, companies demonstrating outstanding family-friendly practices will be selected from among the certified enterprises for inclusion in the list.',
    'register.rules.learnMore': 'Learn Award Criteria',
  },
};
